/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Quick_Position_Required_ToastInputs */

const vi_warehouse_quick_position_required_toast = /** @type {(inputs: Warehouse_Quick_Position_Required_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn vị trí lưu kho trước khi quét.`)
};

/**

* @param {Warehouse_Quick_Position_Required_ToastInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_quick_position_required_toast = /** @type {((inputs?: Warehouse_Quick_Position_Required_ToastInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Quick_Position_Required_ToastInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_quick_position_required_toast(inputs)
});